import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import classNames from "classnames";
import styles from "../assets/jss/material-dashboard-react/components/cardAvatarStyle.js";

// Base styled component
const CardAvatarRoot = styled("div", {
  shouldForwardProp: (prop) => prop !== "profile" && prop !== "plain",
})(({ profile, plain }) => ({
  ...styles.cardAvatar,
  ...(profile && styles.cardAvatarProfile),
  ...(plain && styles.cardAvatarPlain),
}));

export default function CardAvatar(props) {
  const { children, className, profile, plain, ...rest } = props;

  return (
    <CardAvatarRoot
      className={classNames(className)}
      profile={profile ? 1 : 0}
      plain={plain ? 1 : 0}
      {...rest}
    >
      {children}
    </CardAvatarRoot>
  );
}

CardAvatar.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  profile: PropTypes.bool,
  plain: PropTypes.bool,
};
